// 使用公钥加密密码
/**
 * 使用从接口获取的公钥加密数据，并返回Vault格式的密文
 * @param {string} plaintext - 要加密的明文数据
 * @param {Object} publicKeyObj - 接口返回的响应数据，包含公钥和版本信息
 * @returns {Promise<string>} 返回Vault格式的密文字符串
 */
async function importPublicKey(pem: string) {
  const b64 = pem
    .replace(/-----BEGIN PUBLIC KEY-----/, "")
    .replace(/-----END PUBLIC KEY-----/, "")
    .replace(/\s/g, "");
  const binaryDer = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  return await crypto.subtle.importKey(
    "spki",
    binaryDer.buffer,
    { name: "RSA-OAEP", hash: "SHA-256" },
    true,
    ["encrypt"]
  );
}

async function encryptData(publicKey: CryptoKey, data: string) {
  const encoder = new TextEncoder();
  const encoded = encoder.encode(data);
  const encrypted = await crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    publicKey,
    encoded
  );
  return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}

export async function encryptToVaultFormat(
  plaintext: string,
  publicKeyObj: { public_key: string; version: number }
): Promise<string> {
  // 拼接 PEM 格式
  const publicKeyPem = `-----BEGIN PUBLIC KEY-----\n${(
    publicKeyObj?.public_key?.match(/.{1,64}/g) ?? []
  ).join("\n")}\n-----END PUBLIC KEY-----`;
  const keyVersion = publicKeyObj.version;

  try {
    const publicKey = await importPublicKey(publicKeyPem);
    const encrypted = await encryptData(publicKey, plaintext);

    // 拼接 Vault 所需格式 v<version>:<密文>
    return `v${keyVersion}:${encrypted}`;
  } catch (error) {
    console.error("加密过程中发生错误:", error);
    throw error;
  }
}
